import { render, staticRenderFns } from "./RedisTerminal.vue?vue&type=template&id=b483310a&"
import script from "./RedisTerminal.vue?vue&type=script&lang=js&"
export * from "./RedisTerminal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports